import Axios from 'api/axios'
import type { FraudCaseDetailsResponse, FraudCasePageResponse, FraudCaseResponse, ListFraudCasesParams } from '../types'

const BASE_PATH = '/bo/v2/fraud-cases'

export const listFraudCases = (params?: ListFraudCasesParams): Promise<FraudCasePageResponse> =>
  Axios.get(BASE_PATH, { params }).then(({ data }) => data)

export const getFraudCaseDetails = (fraudCaseId: string): Promise<FraudCaseDetailsResponse> =>
  Axios.get(`${BASE_PATH}/${fraudCaseId}/details`).then(({ data }) => data)

export const markFraudCaseAsNotified = (fraudCaseId: string): Promise<FraudCaseResponse> =>
  Axios.post(`${BASE_PATH}/${fraudCaseId}/notify`).then(({ data }) => data)

export const closeFraudCase = (fraudCaseId: string): Promise<FraudCaseResponse> =>
  Axios.post(`${BASE_PATH}/${fraudCaseId}/close`).then(({ data }) => data)

export const markTransactionAsFraud = (fraudCaseId: string, transactionId: string): Promise<FraudCaseResponse> =>
  Axios.post(`${BASE_PATH}/${fraudCaseId}/transactions/${transactionId}/mark-fraud`).then(({ data }) => data)

export const markTransactionAsNotFraud = (fraudCaseId: string, transactionId: string): Promise<FraudCaseResponse> =>
  Axios.post(`${BASE_PATH}/${fraudCaseId}/transactions/${transactionId}/mark-not-fraud`).then(({ data }) => data)
